export const CLIENT_SETUP_IAC = {
  enableIACCheckonLogin: ["0831"],
};
